export default "__VITE_ASSET__DTngSJJ5__"